<h3>Want to help make this project awesome? Check out our repo.</h3>
<a href="https://github.com/bfwg/angular-spring-jwt-starter" color="accent" mat-raised-button mat-ripple>
  <span>GITHUB</span>
</a>
